import React from 'react';
import './Skeleton.css';

const Skeleton = ({ width, height, borderRadius, margin, className }) => {
  const style = {
    width: width || '100%',
    height: height || '20px',
    borderRadius: borderRadius || '4px',
    margin: margin || '0',
  };

  return <div className={`skeleton-loader ${className || ''}`} style={style}></div>;
};

export const TableSkeleton = ({ rows = 5, columns = 5 }) => {
  return (
    <div className="table-skeleton">
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div key={rowIndex} className="table-skeleton-row">
          {Array.from({ length: columns }).map((_, colIndex) => (
            <Skeleton key={colIndex} height="32px" />
          ))}
        </div>
      ))}
    </div>
  );
};

export default Skeleton;
